export const COMPANY_OPTIONS = [
  {
    code: 'M5005',
    name: 'ADLOGIC TECHNOLOGY PTE. LTD.',
    label: 'ADLOGIC TECHNOLOGY PTE. LTD.（M5005）',
  },
  {
    code: 'M5006',
    name: 'Mintegral International Limited',
    label: 'Mintegral International Limited（M5006）',
  },
  {
    code: 'M6003',
    name: 'MINTEGRAL PTE. LTD.',
    label: 'MINTEGRAL PTE. LTD.（M6003）',
  },
  {
    code: 'M7005',
    name: 'Mintegral North America Inc.',
    label: 'Mintegral North America Inc.（M7005）',
  },
  {
    code: 'M5001',
    name: 'Mobvista International Technology Limited',
    label: 'Mobvista International Technology Limited（M5001）',
  },
]
